import { useNavigate } from 'react-router';
import NextAction from '../../OnBoardingDrawerAction/NextAction';
import styles from './index.module.scss';
import { useOnBoardingDrawer } from '../../OnBoardingDrawerProvider';
import { smsSentStatusEnum } from '../../../../../../services/intakeDataService/types';
import SentSmsDoneView from './SentSmsDoneView';
import SkipSentSmsView from './SkipSentSmsView';
import PhoneNumberForm from './PhoneNumberForm';
import useIntakeData from '../../../../../../services/intakeDataService/index';
import { observer } from 'mobx-react-lite';
import { componentType } from '../../../../../../hooks/useMixpanel';
import { patientTabsUrl } from '../../../../../../Pages/SinglePatientDetails/types';
import useQueryParam from '../../../../../../hooks/useCustomQueryParam';

function InviteSmsStep({
  patientUuid,
  btnClassName,
  mixpanelComponent,
}: {
  patientUuid?: string;
  btnClassName?: string;
  mixpanelComponent?: componentType;
}) {
  const {
    state,
    state: { smsSentStatus },
  } = useIntakeData();
  const navigate = useNavigate();
  const [, setNewPatient] = useQueryParam<string | undefined>('newPatientUuid');
  const {
    contextData: { patient },
  } = useOnBoardingDrawer();

  const onFinish = () => {
    if (smsSentStatus === smsSentStatusEnum.inProgress) {
      state.updateSMSStatus(smsSentStatusEnum.Cancelled);
    } else {
      setNewPatient(undefined);

      if(patient?.uuid) {
        navigate(`/patients/${patient?.uuid}/${patientTabsUrl.profile}`);
      }
    }
  };

  return (
    <div className={styles.root}>
      {smsSentStatus === smsSentStatusEnum.Cancelled ? (
        <SkipSentSmsView />
      ) : smsSentStatus === smsSentStatusEnum.Done ? (
        <SentSmsDoneView patientUuid={patientUuid ?? patient?.uuid} />
      ) : (
        <PhoneNumberForm
          patientUuid={(patientUuid ?? patient?.uuid) as string}
          mixpanelComponent={mixpanelComponent}
        />
      )}
      <NextAction
        testid={smsSentStatus === smsSentStatusEnum.Cancelled ? 'finish-registration' : 'invite-sms-proceed'}
        onClick={onFinish}
        btnText={'Finish Registration'}
        btnClassName={btnClassName}
      />
    </div>
  );
}

export default observer(InviteSmsStep);
